"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageButton = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var button_1 = require("../styled/button");

var PageButton = function PageButton(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      index = _a.index;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Pagination-PageButton',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _b = (0, react_1.useContext)(context_1.PaginationContext),
      onChange = _b.onChange,
      pageLabel = _b.pageLabel,
      currentLabel = _b.currentLabel,
      currentPage = _b.currentPage,
      isInverse = _b.isInverse;

  var onClick = function onClick() {
    return onChange(index);
  }; // NOTE: While NVDA announces most of the possible values accurately, it does
  // not make a difference between aria-current="true" and aria-current="false".


  if (currentPage === index) {
    return react_1.default.createElement(button_1.Button, {
      className: rootClasses,
      "aria-label": "".concat(currentLabel, " ").concat(index),
      onClick: onClick,
      "aria-current": "true",
      isCurrent: true,
      isInverse: isInverse
    }, index);
  }

  return react_1.default.createElement(button_1.Button, {
    className: rootClasses,
    "aria-label": "".concat(pageLabel, " ").concat(index),
    onClick: onClick,
    isInverse: isInverse
  }, index);
};

var PageButtonWithSpace = (0, ui_helper_with_space_1.withSpace)(PageButton);
exports.PageButton = PageButtonWithSpace;